export default __webpack_public_path__ + "static/media/saved.1d6474f8.svg";